module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    attrs: {
      "id": "app"
    }
  }, [(this.$route.meta.screen === true) ? _c('div', {
    staticClass: "main-container"
  }, [_c('router-view')], 1) : [_c('x-header', {
    staticStyle: {
      "position": "relative",
      "z-index": "99999999"
    }
  }), _vm._v(" "), (this.$route.meta.isKeepAlive === false) ? _c('div', {
    staticClass: "main-container"
  }, [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1) : _c('div', {
    staticClass: "main-container"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1), _vm._v(" "), _c('x-footer')]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e59829ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1673
// module chunks = 1